import { render, staticRenderFns } from "./LoginForAdult.vue?vue&type=template&id=4f4783f8&scoped=true"
import script from "./LoginForAdult.vue?vue&type=script&lang=js"
export * from "./LoginForAdult.vue?vue&type=script&lang=js"
import style0 from "./LoginForAdult.vue?vue&type=style&index=0&id=4f4783f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4783f8",
  null
  
)

export default component.exports